export default __webpack_public_path__ + "static/media/completePizza.c56b56c3.png";